export default __webpack_public_path__ + "static/media/no-photo-icon2.607212e5.svg";